export default __webpack_public_path__ + "static/media/DIGIBIM_Logo.6ceae31e.png";